export const useShowValidationToasts = (errorResponse) => {
try {
    for (const [field, messages] of Object.entries(errorResponse)) {
        if (Array.isArray(messages)) {
          messages.forEach((msg) => {
            useNuxtApp().$showToast({
              msg: `${field}: ${msg}`,
              type: "error",
            });
          });
        }
      }  
} catch (error) {
    console.error("useShowValidationToasts ",error);
}
  
};
